import { css } from "twin.macro";

export const GenesisVars = css`
:root {
  --genesis-color-base-black: #000000;
  --genesis-color-base-white: #ffffff;
  --genesis-color-base-grey-50: #f2f2f2;
  --genesis-color-base-grey-100: #f5f3f1;
  --genesis-color-base-grey-200: #e5e5e5;
  --genesis-color-base-grey-250: #cccccc;
  --genesis-color-base-grey-300: #b2b2b2;
  --genesis-color-base-grey-400: #999999;
  --genesis-color-base-grey-500: #808080;
  --genesis-color-base-grey-600: #666666;
  --genesis-color-base-grey-700: #4d4d4d;
  --genesis-color-base-grey-800: #333333;
  --genesis-color-base-grey-900: #1a1a1a;
  --genesis-color-base-grey-1000: #0d0d0d;
  --genesis-color-base-nightshade-100: #dadaff;
  --genesis-color-base-nightshade-200: #a0a3ff;
  --genesis-color-base-nightshade-300: #5d5bed;
  --genesis-color-base-nightshade-400: #3438a3;
  --genesis-color-base-nightshade-500: #00063a;
  --genesis-color-base-slate-50: #edf2ed;
  --genesis-color-base-slate-100: #e8eee8;
  --genesis-color-base-slate-200: #d1d9d1;
  --genesis-color-base-slate-250: #cccccc;
  --genesis-color-base-slate-300: #b8c2b8;
  --genesis-color-base-slate-400: #96a396;
  --genesis-color-base-slate-500: #778577;
  --genesis-color-base-slate-600: #586558;
  --genesis-color-base-slate-700: #3c463c;
  --genesis-color-base-slate-800: #212921;
  --genesis-color-base-slate-850: #1b211d;
  --genesis-color-base-slate-900: #001003;
  --genesis-color-base-slate-1000: #000501;
  --genesis-color-base-green-100: #dafed0;
  --genesis-color-base-green-200: #d3ffb0;
  --genesis-color-base-green-300: #affc92;
  --genesis-color-base-green-400: #16cb3e;
  --genesis-color-base-green-500: #12a232;
  --genesis-color-base-green-600: #008753;
  --genesis-color-base-green-700: #004202;
  --genesis-color-base-green-900: #0c2801;
  --genesis-color-base-mustard-100: #fff0c2;
  --genesis-color-base-mustard-200: #ffe699;
  --genesis-color-base-mustard-300: #ffd65c;
  --genesis-color-base-mustard-400: #ffd700;
  --genesis-color-base-mustard-500: #fdbc00;
  --genesis-color-base-mustard-800: #291f00;
  --genesis-color-base-coral-100: #ffe0e0;
  --genesis-color-base-coral-200: #ffd2cf;
  --genesis-color-base-coral-300: #f9afad;
  --genesis-color-base-coral-400: #ee6869;
  --genesis-color-base-coral-800: #4d2122;
  --genesis-color-base-red-100: #ffe8e6;
  --genesis-color-base-red-500: #f04438;
  --genesis-color-base-red-600: #cd221c;
  --genesis-color-base-red-800: #aa0000;
  --genesis-color-base-lavender-200: #dec9ec;
  --genesis-color-base-lavender-400: #895ba7;
  --genesis-color-base-yellow-500: #ebed08;
  --genesis-color-base-yellow-900: #a3a45f;
  --genesis-color-base-orange-300: #ff9f00;
  --genesis-color-base-sweetcorn-500: #f5f18e;
  --genesis-color-base-lime-500: #a6e566;
  --genesis-color-action-primary: #0c2801;
  --genesis-color-action-secondary: #d1d9d1;
  --genesis-color-action-disabled: #b8c2b8;
  --genesis-color-action-danger: #f04438;
  --genesis-color-action-primary-pressed: #001003;
  --genesis-color-action-secondary-pressed: #cccccc;
  --genesis-color-action-tertiary: #cccccc;
  --genesis-color-action-constructive: #12a232;
  --genesis-color-text-high: #000000;
  --genesis-color-text-mid: #586558;
  --genesis-color-text-low: #b8c2b8;
  --genesis-color-text-on-primary: #ffffff;
  --genesis-color-text-on-secondary: #000000;
  --genesis-color-text-error: #f04438;
  --genesis-color-text-on-danger: #ffffff;
  --genesis-color-text-on-constructive: #ffffff;
  --genesis-color-text-inverted-default: #ffffff;
  --genesis-color-text-inverted-inverted: #000000;
  --genesis-color-containment-primary: #edf2ed;
  --genesis-color-containment-secondary: #d1d9d1;
  --genesis-color-containment-tertiary: #ffffff;
  --genesis-color-containment-inverted: #212921;
  --genesis-color-input-on-primary: #001003;
  --genesis-color-input-on-primary-variant: #96a396;
  --genesis-color-input-on-primary-dim: #b8c2b8;
  --genesis-color-input-surface: #ffffff;
  --genesis-color-input-error: #ee6869;
  --genesis-color-border-higher: #000501;
  --genesis-color-border-high: #16cb3e;
  --genesis-color-border-mid: #b8c2b8;
  --genesis-color-border-regular: #d1d9d1;
  --genesis-color-border-low: #e8eee8;
  --genesis-color-border-error: #ee6869;
  --genesis-color-feedback-information-background: #ffffff;
  --genesis-color-feedback-information-text: #000000;
  --genesis-color-feedback-information-border: #001003;
  --genesis-color-feedback-information-leading-icon: #001003;
  --genesis-color-feedback-error-background: #ffe8e6;
  --genesis-color-feedback-error-text: #1a1a1a;
  --genesis-color-feedback-error-border: #f04438;
  --genesis-color-feedback-error-leading-icon: #f04438;
  --genesis-color-feedback-warning-background: #ffe699;
  --genesis-color-feedback-warning-text: #1a1a1a;
  --genesis-color-feedback-warning-border: #1a1a1a;
  --genesis-color-feedback-warning-leading-icon: #1a1a1a;
  --genesis-color-feedback-success-background: #d3ffb0;
  --genesis-color-feedback-success-text: #1a1a1a;
  --genesis-color-feedback-success-border: #1a1a1a;
  --genesis-color-feedback-success-leading-icon: #1a1a1a;
  --genesis-color-static-spark: #ee6869;
  --genesis-color-static-dark: #000000;
  --genesis-color-static-whisper: #ffe0e0;
  --genesis-color-static-drift: #a0a3ff;
  --genesis-color-static-fuchsia: #3438a3;
  --genesis-color-static-lightjade: #dafed0;
  --genesis-color-static-deepsea: #16cb3e;
  --genesis-color-static-beam: #ffd65c;
  --genesis-color-static-sunglow: #ffd700;
  --genesis-color-static-light: #ffffff;
  --genesis-color-progress-active: #212921;
  --genesis-color-progress-track: #d1d9d1;
  --genesis-color-navbar-background: #ffffff;
  --genesis-color-navbar-active-label: #0c2801;
  --genesis-color-navbar-inactive-label: #b8c2b8;
  --genesis-color-switch-track-off: #d1d9d1;
  --genesis-color-switch-track-on: #12a232;
  --genesis-color-switch-knob-off: #0c2801;
  --genesis-color-switch-knob-on: #ffffff;
  --genesis-color-switch-border: #0c2801;
  --genesis-opacity-10: 0.1;
  --genesis-opacity-20: 0.2;
  --genesis-opacity-30: 0.3;
  --genesis-opacity-40: 0.4;
  --genesis-opacity-50: 0.5;
  --genesis-opacity-60: 0.6;
  --genesis-opacity-70: 0.7;
  --genesis-opacity-80: 0.8;
  --genesis-opacity-90: 0.9;
  --genesis-opacity-100: 1;
  --genesis-border-width-none: 0px;
  --genesis-border-width-regular: 1px;
  --genesis-border-width-thick: 2px;
  --genesis-border-radius-s: 8px;
  --genesis-border-radius-m: 12px;
  --genesis-border-radius-l: 16px;
  --genesis-border-radius-xl: 20px;
  --genesis-border-radius-circle: 999px;
  --genesis-font-family-primary-font: 'Inter';
  --genesis-font-weight-regular: Regular;
  --genesis-font-weight-medium: Medium;
  --genesis-font-weight-semi-bold: Semi Bold;
  --genesis-font-weight-bold: Bold;
  --genesis-font-weight-extra-bold: Extra Bold;
  --genesis-line-height-s: 14;
  --genesis-line-height-m: 16;
  --genesis-line-height-l: 20;
  --genesis-line-height-xl: 24;
  --genesis-line-height-xxxl: 36;
  --genesis-line-height-xxxxl: 40;
  --genesis-letter-spacing-extra-tight: -3;
  --genesis-letter-spacing-tight: -2;
  --genesis-letter-spacing-slightly-tight: -1;
  --genesis-letter-spacing-normal: 0;
  --genesis-letter-spacing-slightly-wide: 1;
  --genesis-font-size-xs: 10px;
  --genesis-font-size-s: 12px;
  --genesis-font-size-m: 14px;
  --genesis-font-size-l: 16px;
  --genesis-font-size-xl: 18px;
  --genesis-font-size-2-xl: 24px;
  --genesis-font-size-3-xl: 32px;
  --genesis-font-size-4-xl: 36px;
  --genesis-font-size-5-xl: 40px;
  --genesis-text-decoration-underline: underline;
  --genesis-text-decoration-strike-through: line-through;
  --genesis-text-decoration-none: none;
  --genesis-text-case-none: none;
  --genesis-text-case-uppercase: uppercase;
  --genesis-text-case-lowercase: lowercase;
  --genesis-text-case-capitalize: capitalize;
  --genesis-motion-duration-x-short: 100;
  --genesis-motion-duration-short: 150;
  --genesis-motion-duration-medium: 200;
  --genesis-motion-duration-long: 300;
  --genesis-motion-duration-x-long: 500;
  --genesis-elevation-bottom-xs: '0px 1px 4px 0px rgba(38,49,58,0.16)';
  --genesis-elevation-bottom-s: '0px 4px 4px 0px rgba(38,49,58,0.04), 0px 8px 16px 0px rgba(38,49,58,0.08)';
  --genesis-elevation-bottom-m: '0px 4px 4px 0px rgba(38,49,58,0.04), 0px 16px 32px 0px rgba(38,49,58,0.16)';
  --genesis-elevation-bottom-l: '0px 6px 6px 0px rgba(38,49,58,0.06), 0px 24px 48px 0px rgba(38,49,58,0.24)';
  --genesis-elevation-top-xs: '0px -1px 4px 0px rgba(38,49,58,0.16)';
  --genesis-elevation-top-s: '0px -4px 4px 0px rgba(38,49,58,0.04), 0px -8px 16px 0px rgba(38,49,58,0.08)';
  --genesis-elevation-top-m: '0px -4px 4px 0px rgba(38,49,58,0.04), 0px -16px 32px 0px rgba(38,49,58,0.16)';
  --genesis-elevation-top-l: '0px -6px 6px 0px rgba(38,49,58,0.06), 0px -24px 48px 0px rgba(38,49,58,0.24)';
  --genesis-elevation-left-s: '-4px 0px 4px 0px rgba(38,49,58,0.04), -8px 0px 16px 0px rgba(38,49,58,0.08)';
  --genesis-elevation-left-m: '-4px 0px 4px 0px rgba(38,49,58,0.04), -16px 0px 32px 0px rgba(38,49,58,0.16)';
  --genesis-elevation-left-l: '-6px 0px 6px 0px rgba(38,49,58,0.06), -24px 0px 48px 0px rgba(38,49,58,0.12)';
  --genesis-elevation-right-s: '4px 0px 4px 0px rgba(38,49,58,0.04), 8px 0px 16px 0px rgba(38,49,58,0.08)';
  --genesis-elevation-right-m: '4px 0px 4px 0px rgba(38,49,58,0.04), 16px 0px 32px 0px rgba(38,49,58,0.16)';
  --genesis-elevation-right-l: '6px 0px 6px 0px rgba(38,49,58,0.06), 24px 0px 48px 0px rgba(38,49,58,0.24)';
  --genesis-sizing-s025: 1px;
  --genesis-sizing-s05: 2px;
  --genesis-sizing-s1: 4px;
  --genesis-sizing-s2: 8px;
  --genesis-sizing-s3: 12px;
  --genesis-sizing-s4: 16px;
  --genesis-sizing-s5: 20px;
  --genesis-sizing-s6: 24px;
  --genesis-sizing-s7: 28px;
  --genesis-sizing-s8: 32px;
  --genesis-sizing-s9: 36px;
  --genesis-sizing-s10: 40px;
  --genesis-sizing-s12: 48px;
  --genesis-sizing-s13: 52px;
  --genesis-sizing-s14: 56px;
  --genesis-sizing-s15: 60px;
  --genesis-sizing-s16: 64px;
  --genesis-sizing-s18: 72px;
  --genesis-sizing-s20: 80px;
  --genesis-sizing-s21: 84px;
  --genesis-sizing-s22: 88px;
  --genesis-sizing-s24: 96px;
  --genesis-sizing-s26: 104px;
  --genesis-sizing-s28: 112px;
  --genesis-sizing-s30: 120px;
  --genesis-spacing-s1: 4px;
  --genesis-spacing-s2: 8px;
  --genesis-spacing-s3: 12px;
  --genesis-spacing-s4: 16px;
  --genesis-spacing-s5: 20px;
  --genesis-spacing-s6: 24px;
  --genesis-spacing-s8: 32px;
  --genesis-spacing-s9: 36px;
  --genesis-spacing-s10: 40px;
  --genesis-spacing-s12: 48px;
  --genesis-spacing-s14: 56px;
  --genesis-spacing-s16: 64px;
  --genesis-spacing-s18: 72px;
  --genesis-spacing-s20: 80px;
  --genesis-spacing-s24: 96px;
  --genesis-spacing-s32: 128px;
  --genesis-spacing-s025: 1px;
  --genesis-spacing-s05: 2px;
}
`